export const SYBG_HOURS = 2;
export const USER_ID_COOKIE = 'wf_user';
export const MKTG_CHANNEL_COOKIE = 'wf_mktg_channel';
export const FIRST_TOUCH_COOKIE = 'wf_first_touch';
export const FIRST_TOUCH_COOKIE_V2 = 'wf_first_touch_v2';
export const UTM_SESSION_COOKIE = 'wf_utm_session_values';
export const EXP_UNIQUE_ID_COOKIE = 'wf_exp_uniqueId';
export const SSO_OWNERSHIP_WARNING_LOCALSTORAGE_KEY =
  'wf_sso_ownership_warning_seen';
export const LOGGED_OUT_COOKIE = 'wf_logout';
export const MARKETING_VERTICAL_COOKIE = 'wf_vertical';
export const ANON_ID_COOKIE = 'ajs_anonymous_id';
export {DNSSEC_STATUS} from '@packages/domains/hosting/data-types';
